$(document).ready(function () {

    function initMobileSlick() {
      if ($(window).width() < 768) {

        // Initialize only if not already initialized
        if (!$('.social-proof-container-holder').hasClass('slick-initialized')) {
          $('.social-proof-container-holder').slick({
            dots: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 3000,
            slidesToShow: 1,
            slidesToScroll: 1,
            centermode: false,
            variableWidth: false
          });
        }
      } else {
        // Destroy slick on desktop
        if ($('.social-proof-container-holder').hasClass('slick-initialized')) {
          $('.social-proof-container-holder').slick('unslick');
        }

      }
    }
    // Initial check
    initMobileSlick();

    // Re-check on resize
    $(window).on('resize', function () {
      initMobileSlick();
    });

  });